import {
  Component,
  EventEmitter,
  Injector,
  Output,
  ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'copyAllocationDetailsConfirmModal',
  templateUrl: './copy-allocation-details-confirm-modal.component.html',
  styleUrls: ['copy-allocation-details-confirm-modal.component.less'],
})
export class CopyAllocationDetailsConfirmModalComponent extends AppComponentBase {
  @ViewChild('modal', { static: true }) modal: ModalDirective;
  options: any;

  @Output() approveCopy$: EventEmitter<Date> = new EventEmitter<Date>();

  constructor(injector: Injector) {
    super(injector);
  }

  show(options: any): void {
    this.options = options;
    this.modal.show();
  }
  close(): void {
    this.modal.hide();
  }

  copy(): void {
    this.approveCopy$.emit(this.options);
    this.modal.hide();
  }
}
